import React from 'react';
import './DogsPage.css';
import { Link } from 'react-router-dom';

const DogsPage: React.FC = () => {
  return (
    <div className="dogs-page">
      <div className="container">
        <div className="page-header">
          <h1>🐕 Dogs</h1>
          <p>Celebrating the heart of our mission — the dogs we serve</p>
        </div>

        {/* Hero Section */}
        <section className="dogs-hero">
          <div className="hero-content">
            <h2>Every Dog Deserves Love</h2>
            <p>
              From vaccination drives to rehabilitation programs, we're working to ensure 
              every street dog in India has access to care, nutrition, and a chance at a 
              better life.
            </p>
          </div>
          <div className="hero-image">
            <div className="placeholder-image">
              🐕‍🦺
              <p>Dogs Hero Image</p>
            </div>
          </div>
        </section>

        {/* Key Initiatives */}
        <section className="initiatives-section">
          <h2>Our Key Initiatives</h2>
          <div className="initiatives-grid">
            <div className="initiative-card">
              <div className="initiative-image">
                <div className="placeholder-image">💉</div>
              </div>
              <div className="initiative-content">
                <h3>Vaccination Drives</h3>
                <p>
                  Building rabies-free zones through organized vaccination campaigns. 
                  We partner with local NGOs to reach dogs in every neighborhood.
                </p>
                <div className="initiative-stats">
                  <div className="stat">
                    <span className="stat-number">500+</span>
                    <span className="stat-label">Dogs Vaccinated</span>
                  </div>
                  <div className="stat">
                    <span className="stat-number">15</span>
                    <span className="stat-label">Cities Covered</span>
                  </div>
                </div>
                <button className="btn btn-primary">Learn More</button>
              </div>
            </div>

            <div className="initiative-card">
              <div className="initiative-image">
                <div className="placeholder-image">🍽️</div>
              </div>
              <div className="initiative-content">
                <h3>Feeding Programs</h3>
                <p>
                  Ensuring daily nutrition for street dogs through partnerships with 
                  local vendors and community support networks.
                </p>
                <div className="initiative-stats">
                  <div className="stat">
                    <span className="stat-number">1000+</span>
                    <span className="stat-label">Daily Meals</span>
                  </div>
                  <div className="stat">
                    <span className="stat-number">50+</span>
                    <span className="stat-label">Vendor Partners</span>
                  </div>
                </div>
                <button className="btn btn-primary">Learn More</button>
              </div>
            </div>

            <div className="initiative-card">
              <div className="initiative-image">
                <div className="placeholder-image">🏠</div>
              </div>
              <div className="initiative-content">
                <h3>Rehabilitation & Co-living</h3>
                <p>
                  Helping injured and abandoned dogs recover and integrate peacefully 
                  with human communities through rehabilitation programs.
                </p>
                <div className="initiative-stats">
                  <div className="stat">
                    <span className="stat-number">200+</span>
                    <span className="stat-label">Dogs Rehabilitated</span>
                  </div>
                  <div className="stat">
                    <span className="stat-number">25</span>
                    <span className="stat-label">Success Stories</span>
                  </div>
                </div>
                <button className="btn btn-primary">Learn More</button>
              </div>
            </div>
          </div>
        </section>

        {/* Success Stories */}
        <section className="success-stories">
          <h2>Success Stories</h2>
          <div className="stories-grid">
            <div className="story-card">
              <div className="story-image">
                <div className="placeholder-image">🐕</div>
              </div>
              <div className="story-content">
                <h3>Buddy's Journey</h3>
                <p>
                  Coco is street dog who was rescued by @pawsandtails. 
                  She had distemper and a fractured jaw.
                   The doctores said that she would not be able to survive.
                    But she survived through the many hardships and hopless days.             </p>
                <div className="story-tags">
                  <span className="tag">Rescue</span>
                  <span className="tag">Rehabilitation</span>
                  <span className="tag">Community</span>
                </div>
              </div>
            </div>

            <div className="story-card">
              <div className="story-image">
                <div className="placeholder-image">🐕‍🦺</div>
              </div>
              <div className="story-content">
                <h3>Luna's New Family</h3>
                <p>
                  Oliver was rescued by @pawsandtails. 
                  He was rescued by a local who risked her life for him and then took him to this NGO.
                   He had severe injuries from dog bites and was in a critical condition. 
                   He was nursed back to health and now he is a happy dog.
                </p>
                <div className="story-tags">
                  <span className="tag">Vaccination</span>
                  <span className="tag">Adoption</span>
                  <span className="tag">Happy Ending</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Get Involved */}
        <div style={{ textAlign: 'center', margin: '3rem 0' }}>
          <Link to="/how-to-help" className="btn btn-primary" style={{ fontSize: '1.3rem', padding: '1.2rem 2.5rem' }}>
            How You Can Help
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DogsPage; 